<template>
    <div class="footer">
        <div class="logo-box">
            <img class="logo" src="../assets/logo.webp" alt="CRASPTY AGRISEAD PRIVATE LIMITED Logo" />
            <div class="logo-text">CRASPTY AGRISEAD PRIVATE LIMITED</div>
        </div>
        <div class="contact-list">
            <div class="contact" v-for="(item, index) in list" :key="index">
                <img class="item-icon" :src="item.icon" alt="">
                <div class="item-text">{{ item.title }}</div>
            </div>
        </div>
        <div class="bottom">
            © 2026 Copyright belongs to CRASPTY AGRISEAD PRIVATE LIMITED
        </div>
    </div>
</template>
<script setup>
const list = [
    {
        title: 'tech@craspty.com',
        icon: require('../assets/footer-icon1.webp')
    },
    {
        title: `213.214 2ndfloor Welldone, Tech Park Sohnaroad sec48, Sohna Adda, Sohna Adda, Gurgaon- 122001, Haryana`,
        icon: require('../assets/footer-icon2.webp')
    },
    {
        title: '+91 9507903398',
        icon: require('../assets/footer-icon3.webp')
    },
]
</script>
<style lang="less" scoped>
.footer {
    width: 100%;
    height: auto;
    background: #393939;
    padding: 0 270px;
    box-sizing: border-box;

    .logo-box {
        padding-top: 48px;
        display: flex;
        align-items: center;
        margin-bottom: 41px;

        .logo {
            width: 60px;
            height: 60px;
            border-radius: 8px 8px 8px 8px;
            object-fit: cover;
            margin-right: 14px;
        }

        .logo-text {
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            line-height: 24px;
            letter-spacing: 1px;
            text-shadow: 0px 1px 0px #333333;
        }
    }

    .contact-list {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-bottom: 38px;
        border-bottom: 1px solid rgba(255, 255, 255, 0.2);

        .contact {
            display: flex;
            justify-content: start;
            align-items: center;

            .item-icon {
                width: auto;
                height: 15px;
                object-fit: contain;
                margin-right: 8px;
            }

            .item-text {
                max-width: 394px;
                font-weight: 400;
                font-size: 15px;
                color: #FFFFFF;
                line-height: 20px;
                text-shadow: 0px 1px 0px #333333;
            }
        }
    }

    .bottom {
        font-weight: 400;
        font-size: 14px;
        color: #FFFFFF;
        line-height: 18px;
        padding: 15px 0;
        text-shadow: 0px 1px 0px #333333;
        text-align: center;
    }
}
</style>